// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2P5BH","newExpiryDate":"styles_newExpiryDate__d0YeW","footer":"styles_footer__3BULp"};